import type { IMasterDataRawRetailerAssociationRepository } from "@src/domain/repositories/masterData";
import type { GetMasterDataRawRetailerAssociationsDTO } from "@src/domain/dto/masterData";

export class GetMasterDataRawRetailerAssociationsUseCase {
  private readonly repository: IMasterDataRawRetailerAssociationRepository;

  constructor(repository: IMasterDataRawRetailerAssociationRepository) {
    this.repository = repository;
  }

  execute(params: GetMasterDataRawRetailerAssociationsDTO) {
    return this.repository.getRawAssociations(params);
  }
}
